/** The words agree with product mail's (`apps/notification-svc/src/mail/copy/ro.ts`). */
export const ro = {
    intlLocale: 'ro-RO',
    words: {
        session: 'ședință',
        booking: 'rezervare',
        waitlist: 'listă de așteptare',
        membership: 'abonament',
        membershipPlan: 'tip de abonament',
        taster: 'clasă de probă gratuită',
        trialPeriod: 'perioadă gratuită',
        classType: 'tip de curs',
        danceRole: 'rol de dans',
        lead: 'lead',
        follow: 'follow',
        school: 'școală',
        operator: 'operator Rythmo',
    },
    // CONTEXT.md: one word per role in each language, never a synonym.
    roles: {
        OWNER: 'proprietar',
        MANAGER: 'manager',
        TEACHER: 'profesor',
        MEMBER: 'membru',
    },
    credits: { one: '{n} credit', few: '{n} credite', other: '{n} de credite' },
    unknownProblem: 'Ceva n-a mers bine. Încearcă din nou peste câteva momente.',
    problems: {
        // Identity and school selection
        'urn:rythmo:problem:no-grant-at-school': 'Nu ai acces la această școală.',
        'urn:rythmo:problem:school-not-named': 'Alege o școală ca să continui.',
        // Booking
        'urn:rythmo:problem:no-credits': 'Nu mai ai credite. Reîncarcă-ți abonamentul sau cumpără unul ca să rezervi.',
        'urn:rythmo:problem:taster-already-used': 'Ai folosit deja clasa de probă gratuită.',
        'urn:rythmo:problem:already-booked': 'Ai rezervat deja această ședință.',
        'urn:rythmo:problem:not-a-member': 'Nu ești încă membru al acestei școli.',
        'urn:rythmo:problem:booking-not-cancellable': 'Această rezervare nu mai poate fi anulată.',
        'urn:rythmo:problem:booking-not-claimable': 'Locul nu mai așteaptă să fie revendicat. Verifică rezervarea ca să vezi unde se află.',
        'urn:rythmo:problem:session-not-bookable': 'Ședința nu poate fi rezervată: a fost anulată sau a început deja.',
        'urn:rythmo:problem:dance-role-required': 'Alege lead sau follow ca să rezervi această ședință.',
        'urn:rythmo:problem:dance-role-not-accepted': 'Această ședință nu are roluri de dans. Rezerv-o fără să alegi unul.',
        // The school's payments
        'urn:rythmo:problem:school-cannot-accept-payments': 'Școala nu poate primi încă plăți. Întreabă școala sau încearcă mai târziu.',
        // Buying and holding a membership
        'urn:rythmo:problem:membership-already-active': 'Ai deja un abonament activ. Reîncarcă-l sau schimbă tipul de abonament.',
        'urn:rythmo:problem:plan-has-no-quota': 'Acest tip de abonament nu poate fi cumpărat încă. Întreabă școala.',
        'urn:rythmo:problem:no-active-membership': 'Nu ai un abonament de reîncărcat. Cumpără mai întâi unul.',
        'urn:rythmo:problem:membership-has-no-plan': 'Abonamentul ți-a fost oferit de școală, așa că nu poate fi reîncărcat aici. Întreabă școala.',
        'urn:rythmo:problem:plan-retired': 'Școala nu mai vinde tipul tău de abonament. Alege altul.',
        'urn:rythmo:problem:plan-is-recurring': 'Abonamentul tău se reînnoiește singur, așa că nu poate fi reîncărcat. Schimbă tipul de abonament.',
        'urn:rythmo:problem:plan-trial-not-supported': 'Acest tip de abonament nu poate fi cumpărat aici încă. Întreabă școala.',
        'urn:rythmo:problem:membership-payment-overdue': 'Ai o plată restantă pentru abonament. Achit-o ca să continui.',
        'urn:rythmo:problem:no-membership': 'Nu ai încă un abonament la această școală.',
        'urn:rythmo:problem:membership-not-cancellable': 'Acest abonament nu mai poate fi anulat.',
        'urn:rythmo:problem:no-billing-account': 'Nu ai plătit încă online la această școală.',
        // Changing plan
        'urn:rythmo:problem:membership-not-recurring': 'Doar un abonament care se reînnoiește își poate schimba tipul.',
        'urn:rythmo:problem:plan-not-recurring': 'Poți trece doar la un tip de abonament care se reînnoiește.',
        'urn:rythmo:problem:plan-unchanged': 'Ai deja acest tip de abonament.',
        'urn:rythmo:problem:plan-change-queued': 'Ai deja o schimbare programată pentru următoarea reînnoire.',
        'urn:rythmo:problem:plan-change-awaiting-payment': 'Ultima schimbare așteaptă o plată. Finalizeaz-o mai întâi.',
        'urn:rythmo:problem:no-plan-change-queued': 'Nu ai nicio schimbare programată.',
        'urn:rythmo:problem:plan-upgrade-waits-for-renewal': 'Poți trece la un abonament mai mare după ce se termină perioada gratuită.',
        'urn:rythmo:problem:plan-change-settling': 'Ultima schimbare încă se procesează. Încearcă din nou peste un minut.',
        'urn:rythmo:problem:subscription-not-changeable': 'Acest abonament nu poate fi schimbat aici. Întreabă școala.',
        // Refunds
        'urn:rythmo:problem:membership-not-refundable': 'Acest abonament nu poate fi rambursat din Rythmo. Rambursează-l din Stripe Dashboard.',
        'urn:rythmo:problem:refund-exceeds-payment': 'Suma depășește cât se mai poate returna din această plată. Introdu o sumă mai mică.',
        // Card payments
        'urn:rythmo:problem:payment-declined': 'Cardul a fost refuzat. Încearcă alt card sau contactează banca.',
        'urn:rythmo:problem:payment-provider-unavailable': 'Plățile nu sunt disponibile momentan. Încearcă din nou în curând.',
        'urn:rythmo:problem:payment-provider-error': 'Plata nu a putut fi finalizată. Încearcă mai târziu sau întreabă școala.',
    },
};
//# sourceMappingURL=ro.js.map